var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconGoogle = function SvgIconGoogle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H84C92.8366 0 100 7.16344 100 16V84C100 92.8366 92.8366 100 84 100H16C7.16345 100 0 92.8366 0 84V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.472 62.8514L40.72 26.4751C43.419 28.0641 57.029 35.5962 59.227 37.0285L37.979 73.407C35.6552 76.4768 16.528 67.5101 19.472 62.8492V62.8514Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.521 62.8504L59.273 26.4764C56.3025 21.5329 49.9048 19.7365 44.6501 22.6562C39.3955 25.576 37.7955 31.8656 40.766 37.0298L62.014 73.4082C64.9845 78.3495 71.3823 80.1459 76.6369 77.2262C81.662 74.3064 83.4915 67.7939 80.521 62.8549V62.8504Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6659 78.6323C34.5566 78.6323 39.3319 73.9755 39.3319 68.2312C39.3319 62.4868 34.5566 57.8301 28.6659 57.8301C22.7753 57.8301 18 62.4868 18 68.2312C18 73.9755 22.7753 78.6323 28.6659 78.6323Z",
    fill: "#34A853"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconGoogle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_google.4a7830c4a773bc0f08fee363c3224879.svg";